var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-success d-flex justify-content-center flex-column align-items-center text-center"},[_c('i',{staticClass:"font-50",class:_vm.icon}),_c('div',{staticClass:"message-detail"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }